import { isNetquestClient } from './clients';
import { Features, isFeatureEnabled } from '../featureToggles/features';

export interface ICurrencySettings {
  currencySymbol?: string;
  localization?: string;
}

export const formatNumberAsUSDPrice = (number: number): string => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
};

export const formatNumberAsUSDPriceWithoutCurrency = (number: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number);
};

export const getFormattedCurrencySymbol = (value: number, settings?: ICurrencySettings): string => {
  if (!(isFeatureEnabled(Features.CreditPoolExtension) && isNetquestClient())) {
    return formatNumberAsUSDPrice(value);
  }
  const { currencySymbol = 'USD', localization = 'en-US' } = settings ?? {};
  try {
    return new Intl.NumberFormat(localization, {
      style: 'currency',
      currency: currencySymbol.trim()
    }).format(value);

  } catch (e) {
    // Fallback to the default USD format
    return formatNumberAsUSDPrice(value);
  }
};
